import * as Api from '@ViewModels';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { VerbalConsentScripts } from '../../extViewmodels/sdk/models/Telephony';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { type LevStandardQueryMeta } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'telephony/configuration/clientProfile/verbalConsentScripts';

export function useTelephonyVerbalConsentScriptsQuery({
	legalBusinessName,
	domain,
	privacyPolicyUrl,
	subUseCase,
	enabled = true,
}: {
	legalBusinessName?: string;
	domain?: string;
	privacyPolicyUrl?: string;
	subUseCase?: 'MARKETING' | 'CUSTOMER_CARE';
	enabled?: boolean;
}) {
	const userSession = useUserSession();
	const businessName = legalBusinessName?.trim();
	return useQuery({
		enabled: enabled && !!businessName && !!subUseCase,
		queryKey: [BASE_QUERY_KEY, businessName, domain, privacyPolicyUrl, subUseCase],
		queryFn: () =>
			userSession.webServiceHelper.callAsync<VerbalConsentScripts>({
				path: Api.ImpersonationBroker.composeApiUrl({
					queryParams: { legalBusinessName: businessName, domain, privacyPolicyUrl, subUseCase },
					urlPath: BASE_QUERY_KEY,
				}),
				method: 'GET',
			}),
		placeholderData: keepPreviousData,
		meta: {
			errorLogging: { action: 'VerbalConsentScriptsLoad-Error', category: 'TextingRegistration' },
		} satisfies LevStandardQueryMeta,
	});
}
